var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    { ref: "container", staticClass: "h-full" },
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "p-0 header-con",
          attrs: { height: "42px" },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-row align-center justify-between" },
            [
              _c("span", { staticClass: "page-name" }, [
                _c("span", [_vm._v(_vm._s(_vm.pageData.pageName))]),
              ]),
              _vm._t("table-option", function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex flex-row align-center" },
                    [
                      _vm._l(_vm.pageData.tableOptions, function (option) {
                        return [
                          option === "init"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  staticClass: "option-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getinit()
                                    },
                                  },
                                },
                                [_vm._v(" 初始化用户 ")]
                              )
                            : _vm._e(),
                          option === "synchronization"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  staticClass: "option-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.listSyncBtn()
                                    },
                                  },
                                },
                                [_vm._v(" 同步数据 ")]
                              )
                            : _vm._e(),
                          option === "add"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  staticClass: "option-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.listCreateBtn },
                                },
                                [_vm._v("新增 ")]
                              )
                            : _vm._e(),
                          option === "edit"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  staticClass: "option-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.listUpdateBtn },
                                },
                                [_vm._v("修改 ")]
                              )
                            : _vm._e(),
                          option === "details"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  staticClass: "option-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.listDetailsBtn },
                                },
                                [_vm._v("详情 ")]
                              )
                            : _vm._e(),
                          option === "delete"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  staticClass: "option-btn",
                                  attrs: { size: "small", type: "danger" },
                                  on: { click: _vm.listDeleteBtn },
                                },
                                [_vm._v("删除 ")]
                              )
                            : _vm._e(),
                          option === "filter"
                            ? _c(
                                "el-button",
                                {
                                  key: option,
                                  attrs: {
                                    icon: "filter-icon",
                                    plain: "",
                                    size: "small",
                                    type: "primary",
                                  },
                                  on: { click: _vm.showSearchArea },
                                },
                                [_vm._v(" 高级筛选 ")]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "el-main",
        { ref: "main", staticClass: "p-0" },
        [
          _c(
            "div",
            {
              ref: "searchContainer",
              staticClass: "flex flex-col searcher-con",
            },
            [
              _c("transition", { attrs: { name: "fade-transform" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSearch,
                        expression: "showSearch",
                      },
                    ],
                    staticClass: "high-search-area",
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: { disabled: false, inline: true },
                        model: {
                          value: _vm.searcher,
                          callback: function ($$v) {
                            _vm.searcher = $$v
                          },
                          expression: "searcher",
                        },
                      },
                      [
                        _vm._l(_vm.pageData.searchItems, function (row) {
                          return _c(
                            "el-row",
                            { key: row.rowIndex },
                            _vm._l(row.items, function (col, index) {
                              return _c(
                                "el-col",
                                { key: index, attrs: { span: col.span } },
                                [
                                  col.type === "select"
                                    ? _c(
                                        "form-select-item",
                                        _vm._b(
                                          {
                                            ref: `input_${col.code}`,
                                            refInFor: true,
                                            attrs: {
                                              code: col.code,
                                              name: col.name,
                                            },
                                            model: {
                                              value: _vm.searcher[col.code],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  col.code,
                                                  $$v
                                                )
                                              },
                                              expression: "searcher[col.code]",
                                            },
                                          },
                                          "form-select-item",
                                          col.config,
                                          false
                                        )
                                      )
                                    : col.type === "group"
                                    ? _c(
                                        "form-group-search-item",
                                        _vm._b(
                                          {
                                            ref: `input_${col.code}`,
                                            refInFor: true,
                                            attrs: {
                                              code: col.code,
                                              name: col.name,
                                            },
                                            model: {
                                              value: _vm.searcher[col.code],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  col.code,
                                                  $$v
                                                )
                                              },
                                              expression: "searcher[col.code]",
                                            },
                                          },
                                          "form-group-search-item",
                                          col.config,
                                          false
                                        )
                                      )
                                    : col.type === "date"
                                    ? _c(
                                        "form-date-item",
                                        _vm._b(
                                          {
                                            ref: `input_${col.code}`,
                                            refInFor: true,
                                            attrs: {
                                              code: col.code,
                                              name: col.name,
                                            },
                                            model: {
                                              value: _vm.searcher[col.code],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  col.code,
                                                  $$v
                                                )
                                              },
                                              expression: "searcher[col.code]",
                                            },
                                          },
                                          "form-date-item",
                                          col.config,
                                          false
                                        )
                                      )
                                    : col.type === "popup"
                                    ? _c(
                                        "form-popup-item",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              ref: `input_${col.code}`,
                                              refInFor: true,
                                              attrs: {
                                                code: col.code,
                                                name: col.name,
                                              },
                                              model: {
                                                value: _vm.searcher[col.code],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searcher,
                                                    col.code,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searcher[col.code]",
                                              },
                                            },
                                            "form-popup-item",
                                            col.config,
                                            false
                                          ),
                                          col.handleEvent
                                        )
                                      )
                                    : col.type === "time"
                                    ? _c(
                                        "form-time-item",
                                        _vm._b(
                                          {
                                            ref: `input_${col.code}`,
                                            refInFor: true,
                                            attrs: {
                                              code: col.code,
                                              name: col.name,
                                            },
                                            model: {
                                              value: _vm.searcher[col.code],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  col.code,
                                                  $$v
                                                )
                                              },
                                              expression: "searcher[col.code]",
                                            },
                                          },
                                          "form-time-item",
                                          col.config,
                                          false
                                        )
                                      )
                                    : col.type === "datetime"
                                    ? _c(
                                        "form-datetime-item",
                                        _vm._b(
                                          {
                                            ref: `input_${col.code}`,
                                            refInFor: true,
                                            attrs: {
                                              code: col.code,
                                              name: col.name,
                                            },
                                            model: {
                                              value: _vm.searcher[col.code],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  col.code,
                                                  $$v
                                                )
                                              },
                                              expression: "searcher[col.code]",
                                            },
                                          },
                                          "form-datetime-item",
                                          col.config,
                                          false
                                        )
                                      )
                                    : _c(
                                        "form-text-item",
                                        _vm._b(
                                          {
                                            ref: `input_${col.code}`,
                                            refInFor: true,
                                            attrs: {
                                              code: col.code,
                                              name: col.name,
                                            },
                                            model: {
                                              value: _vm.searcher[col.code],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  col.code,
                                                  $$v
                                                )
                                              },
                                              expression: "searcher[col.code]",
                                            },
                                          },
                                          "form-text-item",
                                          col.config,
                                          false
                                        )
                                      ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        }),
                        _c("el-form-item", [
                          _c(
                            "div",
                            { staticClass: "w-full flex flex-row justify-end" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.searchBtn },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.resetBtn },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              attrs: {
                border: true,
                data: _vm.tableData,
                fit: true,
                "highlight-current-row": true,
                "max-height": _vm.tableMaxHeight,
                "select-on-indeterminate": true,
                stripe: true,
                "cell-class-name": "ik-list-table-body-cell",
                "element-loading-text": "加载中...",
                "header-cell-class-name": "ik-list-table-header-cell",
                "header-row-class-name": "ik-list-table-header-row",
                "row-class-name": "ik-list-table-body-row",
              },
              on: { "row-click": _vm.rowClick },
            },
            [
              _vm._l(_vm.pageData.columns, function (column, index) {
                return [
                  column.type === "oss"
                    ? _c(
                        "table-image-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                          },
                          "table-image-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "file"
                    ? _c(
                        "table-file-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                          },
                          "table-file-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "number"
                    ? _c(
                        "table-number-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                          },
                          "table-number-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "datetime"
                    ? _c(
                        "table-datetime-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                          },
                          "table-datetime-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "group"
                    ? _c(
                        "table-group-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              "data-down": _vm.loading,
                              name: column.name,
                            },
                          },
                          "table-group-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "video"
                    ? _c(
                        "table-group-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              name: column.name,
                              "key-field": "key",
                              "value-field": "value",
                            },
                          },
                          "table-group-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "time"
                    ? _c(
                        "table-time-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                          },
                          "table-time-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "select"
                    ? _c(
                        "table-select-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              name: column.name,
                              "key-field": "key",
                              "value-field": "value",
                            },
                          },
                          "table-select-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "editor"
                    ? _c(
                        "table-editor-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                            on: { showContent: _vm.contentShow },
                          },
                          "table-editor-item",
                          column.config,
                          false
                        )
                      )
                    : _c(
                        "table-text-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: { code: column.code, name: column.name },
                          },
                          "table-text-item",
                          column.config,
                          false
                        )
                      ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-footer",
        { ref: "pagination", staticClass: "p-0", attrs: { height: "auto" } },
        [
          _c("el-pagination", {
            staticClass: "w-full",
            attrs: {
              "current-page": _vm.pagination.pageNo,
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.totalCount,
              background: "",
              layout: "total,->, prev, pager, next,sizes,jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.pagination, "pageNo", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.pagination, "pageNo", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.pagination, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.pagination, "pageSize", $event)
              },
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: `查看内容`,
            visible: _vm.dialogVisible,
            top: "5vh",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "600px", overflow: "auto" } },
            [
              _vm.dialogVisible
                ? _c("show-content", {
                    attrs: {
                      field: _vm.currentField,
                      row: _vm.currentRow,
                      "row-code": _vm.currentRowCode,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }